






















































import { FromStore } from "@abaco/web-common/src/app";
import { Component, Inject, Mixins } from "vue-property-decorator";
import { default as MaltaModule, MODULE_ID, PORTAL_TARGET } from "../../index";
import Utils from "../../mixins/Utils";
import { Measure } from "../../models/ProjectProposal";
import { formatInTimeZone } from "date-fns-tz";
import ProjectProposalMixin from "../../mixins/ProjectProposal";

@Component
export default class ProjectProposalNew extends Mixins(ProjectProposalMixin, Utils) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @FromStore(MODULE_ID) isSignleSubject!: boolean;

    loading = true;
    acceptTermsCondition = false;
    measures: Measure[] | null = null;
    selectedModule = "";
    tableHeaders = ["", "Programme", "Intervention", "Description", "Batch", "", "Deadline"];

    get termsCondition(): string {
        return `${this.measures?.find(x => x.moduleCode === this.selectedModule)?.disclaimer}`;
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    get canShowStartBtn(): boolean {
        return this.acceptTermsCondition && !!this.selectedModule ;
    }

    get isModuleDisabled(): (item: Measure) => boolean {
        return (item: Measure) => {
            const code = String(item.moduleCode || '')
                .toUpperCase()
                .trim();

        return (
            item.disabled === true ||
            code === 'SP_I177_3_M' ||
            code === 'SP_I177_1_2'
        );
        }
    }


    back() {
        this.$router.push({ name: "contractsList", params: { id: this.subjectId } });
    }

    rules = [(v: string) => v || "Accept terms and condition"];

    async mounted() {
        this.currentContract = null;
        const [resp, err] = await this.maltaModule.projectProposalApi.getMeasures(this.subjectId);
        if (err) {
            if (err.response && err.response.status !== 401) {
                this.toast(this.i18n("subject-not-found").toString(), { type: "error" });
                this.$router.push({ name: "contractsList", replace: true, params: { id: this.subjectId } });
            }
        } else if (resp?.measures) {
            this.measures = resp.measures;
        }
        this.loading = false;
    }

    getParsedDate(date: number) {
        return formatInTimeZone(new Date(date * 1000), "Europe/Paris", "dd MMMM yyyy - HH:mm");
    }

    async save() {
        if (this.selectedModule) {
            const [resp, err] = await this.maltaModule.projectProposalApi.createProjectProposal(
                this.subjectId,
                this.selectedModule
            );
            if (err) {
                if (err.response && err.response.status === 500 && err.response?.data?.i18n)
                    this.toast(this.i18n(err.response.data.i18n).toString(), { type: "error", duration: 7000 });
                else this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
            } else if (resp && resp.appId) {
                this.$emit("reload", true, resp.appId);
                const params = { applicationId: resp.appId.toString() };
                this.$router.replace({ name: "project-proposal-home", params });
            } else this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
        }
    }
}
